<ion-menu side="end"
          contentId="root-component"
          type="overlay"
          menuId="chat-menu"
          (ionWillOpen)="onWillOpen()"
          (ionDidOpen)="onDidOpen()"
          (ionDidClose)="onDidClose()">
    <ion-header>
        <ion-toolbar color="primary">
            <ion-title>{{ chatService.address }}</ion-title>
            <ion-buttons slot="start">
                <ion-menu-toggle menu="chat-menu">
                    <ion-button>
                        <ion-icon slot="icon-only" name="close"></ion-icon>
                    </ion-button>
                </ion-menu-toggle>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
    <ion-content class="nb-theme-default">
        <nb-chat title="{{ messageThread?.get('agentName') }}" [scrollBottom]="true">
            <nb-chat-message *ngFor="let msg of displayedMessages"
                             [type]="msg.type"
                             [message]="msg.text"
                             [reply]="msg.reply"
                             [sender]="msg.user.name"
                             [date]="msg.date"
                             [files]="msg.files"
                             [avatar]="msg.user.avatar">
            </nb-chat-message>

            <nb-chat-form (send)="sendMessage($event)"
                          [dropFiles]="true"
                          messagePlaceholder="Type a message or drag & drop a file or a group of files">
            </nb-chat-form>
        </nb-chat>
    </ion-content>
</ion-menu>
